import React, { useState, useEffect } from 'react'; 
import AbstractFpsTransDetails from './AbstractFpsTransDetails';
import { formatDateToYYYY_MM_DD } from "../../Utils/DateUtils";
import GetDistricts from "../../Dropdowns/getDistricts";

const AbstractFpsTransReport = ({ heading }) => {
    
     const [renderContent, setRenderContent] = useState(null);
     const [loadingDistricts, setLoadingDistricts] = useState(true); 
     //todays date 
     const getTodayDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, "0"); 
        const day = String(today.getDate()).padStart(2, "0"); 
        return `${year}-${month}-${day}`;
      };
      getTodayDate();
      const [selectedDate, setSelectedDate] = useState(getTodayDate());

    const handleDistrictLoadingChange = (isLoading) => {
        setLoadingDistricts(isLoading);
    };
    const handleChange = (event) => {
        setSelectedDate(event.target.value);   
      };
    
      //do not remove the below handle
    const handleDistrictChange = (dist_code) => {        
       };
    // Handling form submission
    const handleSubmit = () => {
        const dist_code = document.getElementById('dist_code').value;
        const trans_date = document.getElementById('trans_date').value; 

        if ( dist_code == null || dist_code==0 || dist_code ==''  ) {
            alert('Please select District');
        } else  if ( trans_date == null  || trans_date==0 || trans_date ==''  ) {
            alert('Please select Date');          
        }    else {
            const formatted_date = formatDateToYYYY_MM_DD(trans_date);

            setRenderContent(null);

            setTimeout(() => {
                setRenderContent(
                    <AbstractFpsTransDetails 
                     dist_code={dist_code} 
                     date={formatted_date} 
                     heading={heading} />
                );
            }, 0);
                }
    };

    return (
        <>
            <div className="wrapper row3">
                <div id="container">
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <table width="30%">
                            <thead>
                                <tr className="tableheader">
                                    <th colSpan={8}>{heading}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>District</td>
                                    <td><GetDistricts onLoadingChange={handleDistrictLoadingChange}
                                          onChange={handleDistrictChange} /></td>
                                    <td>Date</td>
                                    <td><input type="date"   name="trans_date"  id="trans_date" 
                                         value = {selectedDate} onChange={handleChange} /> </td>
                                </tr>
                                <tr>
                                    <td colSpan={8} align="center">
                                    <button onClick={handleSubmit} className="button button2" 
                                    disabled={loadingDistricts }
                                    >
                                    Submit
                                    </button>
                                    <button className="button button2">
                                        Back
                                    </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <br />
                    <div id="loading" style={{ display: 'none', textAlign: 'center' }}>
                        <img src="images/progress.gif" alt="Loading" />
                    </div>
                    <br />
                    {/* Render the dynamic content here */}
                    <div id="detailsER">{renderContent}</div>
                </div>
            </div>
        </>
    );
};

export default AbstractFpsTransReport;
